import React from "react";
import { Card, CardTitle, CardBody } from "components/ui/Card";
import Spinner from "components/ui/Spinner";
import { NoClasses } from "./MyClassesCard/NoClasses";
import { Courses } from "./MyClassesCard/Courses";
import { getMyStatus } from "data/slices/myStatus";
import { fetchCourses } from "data/slices/users/courses";
import { dispatchSlice } from "../hooks/dispatchSlice";
import { dispatchUserSlice } from "../hooks/dispatchUserSlice";
import { useActiveRoles } from "../hooks/useRoles";
import { useUser } from "../hooks/useUser";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+My+Classes+Card
//
// Set GRADING_IN_PROGRESS_CLASSES=true in env.local to see classes in the MyClassesCard
// during the time between grading and then end of the semester
export function MyClassesCard() {
  dispatchSlice(getMyStatus);
  dispatchUserSlice(fetchCourses);

  const activeRoles = useActiveRoles();
  const isOnlyApplicant = activeRoles.every((item) => item === "applicant");

  const {
    loadState = "pending",
    current_term: currentTerm,
    classes: rawClasses = [],
    gradingInProgressClasses = [],
  } = useUser((user) => user.courses) || {};

  const classes =
    process.env.GRADING_IN_PROGRESS_CLASSES === "true"
      ? gradingInProgressClasses
      : rawClasses;

  const showCard = !isOnlyApplicant;

  if (showCard) {
    return (
      <Card data-testid="my-classes-card">
        <CardTitle>
          <h2>
            My Classes <span>{currentTerm}</span>
          </h2>
        </CardTitle>

        {loadState === "pending" && (
          <CardBody>
            <Spinner />
          </CardBody>
        )}

        {loadState === "success" && classes.length > 0 && <Courses />}
        {loadState === "success" && classes.length === 0 && <NoClasses />}
      </Card>
    );
  }
  return null;
}
MyClassesCard.displayName = "MyClassesCard";
